var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83511 18.8671C13.2672 18.8671 15.4009 17.3204 16.7529 15.5027L14.3171 13.3022C13.8403 14.2558 11.811 15.6862 9.83511 15.6862C6.73779 15.6862 4.3881 13.0195 4.3881 9.65522C4.3881 6.29089 6.73779 3.80769 9.83511 3.80769C11.811 3.80769 12.8867 4.7197 13.8403 5.6733L16.3691 3.28928C15.0117 1.70196 12.9505 0.443359 9.83511 0.443359C4.62841 0.443359 0.489746 4.1815 0.489746 9.65522C0.489746 15.1289 4.62841 18.8671 9.83511 18.8671Z",
    fill: "#4274F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClever);
export default __webpack_public_path__ + "static/media/clever.b039d088.svg";
export { ForwardRef as ReactComponent };